// extracted by mini-css-extract-plugin
export default {"headingAnchor":"markdown-heading-module--headingAnchor--20710","anchor":"markdown-heading-module--anchor--44177","hashLink":"markdown-heading-module--hashLink--ecf31"};